@file:OptIn(InternalResourceApi::class)

package fr.frux.feature.site.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/fr.frux.feature.site.resources/"

@delegate:ResourceContentHash(1_229_918_150)
internal val Res.string.site_species_search_clear: StringResource by lazy {
      StringResource("string:site_species_search_clear", "site_species_search_clear", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7083, 61),
      ))
    }

@delegate:ResourceContentHash(1_684_673_436)
internal val Res.string.site_steward_manager: StringResource by lazy {
      StringResource("string:site_steward_manager", "site_steward_manager", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7201, 48),
      ))
    }

@delegate:ResourceContentHash(-1_946_731_301)
internal val Res.string.site_steward_none: StringResource by lazy {
      StringResource("string:site_steward_none", "site_steward_none", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7250, 57),
      ))
    }

@delegate:ResourceContentHash(251_305_888)
internal val Res.string.site_steward_owner: StringResource by lazy {
      StringResource("string:site_steward_owner", "site_steward_owner", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7308, 58),
      ))
    }

@delegate:ResourceContentHash(1_517_135_839)
internal val Res.string.site_trees_add_hint: StringResource by lazy {
      StringResource("string:site_trees_add_hint", "site_trees_add_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7367, 159),
      ))
    }

@delegate:ResourceContentHash(1_075_342_147)
internal val Res.string.site_trees_count: StringResource by lazy {
      StringResource("string:site_trees_count", "site_trees_count", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7527, 44),
      ))
    }

@delegate:ResourceContentHash(762_493_879)
internal val Res.string.site_trees_none: StringResource by lazy {
      StringResource("string:site_trees_none", "site_trees_none", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7572, 75),
      ))
    }

@delegate:ResourceContentHash(-1_289_563_552)
internal val Res.string.site_trees_title: StringResource by lazy {
      StringResource("string:site_trees_title", "site_trees_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7648, 52),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString1Resources(map: MutableMap<String, StringResource>) {
  map.put("site_species_search_clear", Res.string.site_species_search_clear)
  map.put("site_steward_manager", Res.string.site_steward_manager)
  map.put("site_steward_none", Res.string.site_steward_none)
  map.put("site_steward_owner", Res.string.site_steward_owner)
  map.put("site_trees_add_hint", Res.string.site_trees_add_hint)
  map.put("site_trees_count", Res.string.site_trees_count)
  map.put("site_trees_none", Res.string.site_trees_none)
  map.put("site_trees_title", Res.string.site_trees_title)
}
